import axios from 'axios';
import { getUserName, getUserToken } from '../../utils/localStoarege';
import { clinicDoctorView as clinicDoctorViewApi, localToken, newHudDoctoViewPatchUrl, newHudPackageApiCRUDUrl, newHudPatientApiCRUDUrl } from '../../constants/apis/new_hud_apis';

export const getClinicDoctorView = async (center) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(clinicDoctorViewApi + (center || getUserName()) + "/", config);
    return response;
};

export const getClinicPatientPhotos = async (patientId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patientId + "/photos/?page_size=100", config);
    return response;
};

export const getClinicPatientPdfs = async (patientId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patientId + "/pdfs/?page_size=100", config);
    return response;
};

export const addClinicHudPatientDoses = async (packageId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(newHudPackageApiCRUDUrl + packageId + "/add-dose/", data, config);
    return response;
};

export const patchClinicHudPatientDoctorView = async (data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newHudDoctoViewPatchUrl, data, config);
    return response;
};
